import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    getRes: null,
    exportRes: null,
};

const slice = createSlice({
    name: 'auditLog',
    initialState,
    reducers: {
        getAuditLogsRequest: (state) => { state.loading = true; },
        getAuditLogsSuccess: (state, action) => { state.loading = false; state.getRes = action.payload; },
        getAuditLogsFailure: (state, action) => { state.loading = false; state.getRes = action.payload; },
        resetAuditLogs: (state) => { state.getRes = null; },

        exportAuditLogsRequest: (state) => { state.loading = true; },
        exportAuditLogsSuccess: (state, action) => { state.loading = false; state.exportRes = action.payload; },
        exportAuditLogsFailure: (state, action) => { state.loading = false; state.exportRes = action.payload; },
        resetExportAuditLogs: (state) => { state.exportRes = null; },
    }
});

export const {
    getAuditLogsRequest, getAuditLogsSuccess, getAuditLogsFailure, resetAuditLogs,
    exportAuditLogsRequest, exportAuditLogsSuccess, exportAuditLogsFailure, resetExportAuditLogs,
} = slice.actions;

export default slice.reducer;
